import React, { useState } from "react";
import { FiMail, FiArrowLeft } from "react-icons/fi";
import { API_BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("loading");
    setError("");

    try {
      const res = await fetch(`${API_BASE_URL}/auth/request-password-reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const result = await res.json();
      if (!res.ok) throw new Error(result.error || "Something went wrong");

      setStatus("success");
    } catch (err: any) {
      setStatus("error");
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 pt-20">
      <div className="w-full max-w-md bg-white p-8 rounded shadow">
        <div className="mb-6 flex items-center text-indigo-600 cursor-pointer" onClick={() => navigate("/login")}>
          <FiArrowLeft className="mr-2" />
          <span className="font-medium text-sm">Back to Login</span>
        </div>

        <h2 className="text-2xl font-semibold mb-4 text-gray-800">Forgot Password</h2>

        {status === "success" ? (
          <p className="text-green-600 text-sm">✅ Reset link sent! Please check your email.</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <label className="block mb-2 text-sm font-medium text-gray-700">Email address</label>
            <div className="relative mb-4">
              <FiMail className="absolute left-3 top-3 text-gray-400" />
              <input
                type="email"
                className="pl-10 w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:border-indigo-400"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {error && <p className="text-red-600 text-sm mb-2">❌ {error}</p>}

            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 transition"
              disabled={status === "loading"}
            >
              {status === "loading" ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
